(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[184,2657,6552],{

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 45578:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    baseUniq = __webpack_require__(45652);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ 47635:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[cid]",
      function () {
        return __webpack_require__(33603);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _cid_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./next-seo.config.js
var next_seo_config = __webpack_require__(88518);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/image.js
var components_image = __webpack_require__(84334);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
;// CONCATENATED MODULE: ./src/2.0/cards/event-card.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  color: inherit;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s ease;\n\n  &:hover {\n    transform: translateY(-2px);\n  }\n\n  .event-card-thumb {\n    position: relative;\n    width: 100%;\n    padding-top: 140%;\n    border-radius: 5px;\n    overflow: hidden;\n    background: #f0f0f0;\n\n    img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .event-card-content {\n    padding: 8px 0;\n  }\n\n  .event-card-date {\n    font-size: 18px;\n    color: #e53935;\n    margin: 0 0 4px;\n    font-weight: 500;\n  }\n\n  .event-card-title {\n    font-size: 24px;\n    font-weight: 700;\n    color: #222;\n    margin: 0 0 4px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    line-height: 1.2;\n    min-height: 50px;\n  }\n\n  .event-card-location {\n    font-size: 18px;\n    color: #888;\n    margin: 0;\n    display: flex; /* flex สำหรับ icon + text */\n    align-items: flex-start;\n    gap: 4px;\n    min-height: 38px;\n\n    .location-icon {\n      flex-shrink: 0;\n      margin-top: 2px;\n    }\n\n    .location-text {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      line-height: 1.4;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .event-card-thumb {\n      padding-top: 130%;\n    }\n\n    .event-card-title {\n      font-size: 22px;\n      min-height: unset;\n    }\n\n    .event-card-date {\n      font-size: 20px;\n    }\n\n    .event-card-location {\n      font-size: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var EventCard = function(param) {
    var item = param.item, index = param.index, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventCardWrapper, {
        href: (item === null || item === void 0 ? void 0 : item.event_url) || (item === null || item === void 0 ? void 0 : item.link) || "#",
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: function() {
            return onClick === null || onClick === void 0 ? void 0 : onClick(item, index);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "event-card-thumb",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image["default"], {
                    image: (item === null || item === void 0 ? void 0 : item.vertical_image) || (item === null || item === void 0 ? void 0 : item.image) || "",
                    external: !!(item === null || item === void 0 ? void 0 : item.vertical_image),
                    title: item === null || item === void 0 ? void 0 : item.title,
                    type: "CARD_MEDIUM"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "event-card-content",
                children: [
                    ((item === null || item === void 0 ? void 0 : item.event_start_date) || (item === null || item === void 0 ? void 0 : item.event_end_date)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "event-card-date",
                        children: [
                            item === null || item === void 0 ? void 0 : item.event_start_date,
                            (item === null || item === void 0 ? void 0 : item.event_start_date) && (item === null || item === void 0 ? void 0 : item.event_end_date) ? " - " : "",
                            (item === null || item === void 0 ? void 0 : item.event_end_date) && item.event_end_date
                        ]
                    }),
                    (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "event-card-title",
                        children: item === null || item === void 0 ? void 0 : item.title
                    }),
                    (item === null || item === void 0 ? void 0 : item.event_location) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "event-card-location",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "location-icon",
                                width: "12",
                                height: "12",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                        cx: "12",
                                        cy: "10",
                                        r: "3"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "location-text",
                                children: item === null || item === void 0 ? void 0 : item.event_location
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var event_card = (EventCard);
var EventCardWrapper = styled_components_browser_esm["default"].a(_templateObject());

// EXTERNAL MODULE: ./src/2.0/widgets/widget-breadcrumb.js
var widget_breadcrumb = __webpack_require__(36552);
// EXTERNAL MODULE: ./src/2.0/widgets/widget-heading.js
var widget_heading = __webpack_require__(2657);
// EXTERNAL MODULE: ./src/components/layouts/index.js
var layouts = __webpack_require__(75519);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(15072);
// EXTERNAL MODULE: ./src/constants/layout.js
var layout = __webpack_require__(38864);
// EXTERNAL MODULE: ./src/services/member-auth/utils/decryption-payload.js
var decryption_payload = __webpack_require__(84233);
// EXTERNAL MODULE: ./src/utils/ads/dynamic-ads.js
var dynamic_ads = __webpack_require__(84920);
// EXTERNAL MODULE: ./src/utils/datalayer/send-datalayer.js
var send_datalayer = __webpack_require__(34892);
// EXTERNAL MODULE: ./src/utils/device.js
var device = __webpack_require__(25283);
// EXTERNAL MODULE: ./src/utils/helper.js
var helper = __webpack_require__(39334);
// EXTERNAL MODULE: ./src/utils/services.js
var services = __webpack_require__(73113);
// EXTERNAL MODULE: ./src/utils/useUser.js
var useUser = __webpack_require__(51148);
;// CONCATENATED MODULE: ./pages/[cid]/index.js







function _cid_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  padding-bottom: 20px;\n  button {\n    width: 100%;\n    border: 1px solid #e3e3e3;\n    background-color: #e3e3e3;\n    color: #555555;\n    border-radius: 5px;\n    font-size: 18px;\n    padding: 5px 0;\n    :hover {\n      border: 1px solid #0600e7;\n      background-color: #0600e7;\n      color: #fff;\n      transition: background-color 0.8ms linear;\n    }\n  }\n"
    ]);
    _cid_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .empty-bg {\n    background: unset !important;\n  }\n  .heading-title {\n    font-size: 30pt;\n    font-family: 'DBHelvethaicaXBd', sans-serif;\n  }\n  .block-content {\n    .card-v-content-title {\n      font-size: 24pt !important;\n      font-family: 'DBHelvethaicaXBd', sans-serif !important;\n    }\n    @media (max-width: 690px) {\n      .card-v-content-title {\n        font-size: 20pt !important;\n      }\n      .card-h-content-title {\n        font-size: 16pt !important;\n      }\n    }\n  }\n  /* .block-content {\n    margin-top: 20px;\n  } */\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 24px;\n  margin: 25px 0;\n  min-height: 500px;\n\n  @media (max-width: 1024px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n  .event-card-thumb {\n    border-radius: 0px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
























var PageError = dynamic_default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 31788)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31788)
            ];
        }
    }
});
var DynamicAds = dynamic_default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84920)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84920)
            ];
        }
    }
});
var CardH = dynamic_default()(__webpack_require__.e(/* import() */ 9789).then(__webpack_require__.bind(__webpack_require__, 9789)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9789)
            ];
        }
    }
});
var CardV = dynamic_default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 40166)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40166)
            ];
        }
    }
});
var SectionFullH = dynamic_default()(__webpack_require__.e(/* import() */ 3877).then(__webpack_require__.bind(__webpack_require__, 63877)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63877)
            ];
        }
    }
});
var SectionAffiliate = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(6066), __webpack_require__.e(4929)]).then(__webpack_require__.bind(__webpack_require__, 34929)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34929)
            ];
        }
    }
});
var StickyBox = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1033), __webpack_require__.e(2836)]).then(__webpack_require__.bind(__webpack_require__, 42836));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42836)
            ];
        }
    },
    ssr: false
});
var PageCategory = function(param) {
    var articles = param.articles, nextArticles = param.nextArticles, category = param.category, subCategory = param.subCategory, lastNews = param.lastNews, meta = param.meta, ads = param.ads, dataAffiliate = param.dataAffiliate, dataAdsHeader = param.dataAdsHeader, sectionEvent = param.sectionEvent;
    var _data = (0,useUser/* default */.Z)();
    var sessionSevId = (_data === null || _data === void 0 ? void 0 : _data.user) ? (0,decryption_payload/* decryptionClient */.F)(_data === null || _data === void 0 ? void 0 : _data.user) : null;
    if (articles === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageError, {
            dataAdsHeader: dataAdsHeader,
            sessionSevId: sessionSevId
        });
    }
    var router = (0,next_router.useRouter)();
    /* -------------------------------- START : LOADMORE -------------------------------- */ var nextLinkRef = (0,react.useRef)(nextArticles);
    var listArticlesRef = (0,react.useRef)(articles);
    var ref = (0,react.useState)(articles), listArticles = ref[0], setListArticles = ref[1];
    var ref1 = (0,react.useState)(12), show = ref1[0], setShow = ref1[1];
    var ref2 = (0,react.useState)(true), adsBox = ref2[0], setAdsBox = ref2[1];
    var ref3 = (0,react.useState)(true), isLoad = ref3[0], setIsLoad = ref3[1];
    var ref4 = (0,react.useState)(false), loadData = ref4[0], setLoadData = ref4[1];
    var handleLightBoxClick = function() {
        setAdsBox(false);
    };
    var handleLoad = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var resData, ref, newLists, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadData(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!(nextArticles && isLoad)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,services/* GET_ARTICLES */.M)("".concat(nextLinkRef.current || ""), false, true)
                        ];
                    case 2:
                        resData = _state.sent();
                        // console.log(`${nextLinkRef.current}${convertObjPath({ limit: 20 })}`)
                        if (!isEmpty_default()(resData === null || resData === void 0 ? void 0 : resData.data)) {
                            ;
                            nextLinkRef.current = (resData === null || resData === void 0 ? void 0 : resData.nextTo) || (resData === null || resData === void 0 ? void 0 : (ref = resData.links) === null || ref === void 0 ? void 0 : ref.next);
                            newLists = (0,_to_consumable_array/* default */.Z)(listArticlesRef.current).concat((0,_to_consumable_array/* default */.Z)(resData === null || resData === void 0 ? void 0 : resData.data));
                            listArticlesRef.current = uniqBy_default()(newLists, "id");
                            setListArticles(listArticlesRef.current);
                        }
                        _state.label = 3;
                    case 3:
                        setShow(show + 12);
                        setIsLoad(!isLoad);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        console.error("".concat((0,helper/* timestamp */.AB)(), " ==========> LOAD_CATEGORY_LIST ERROR : ").concat(nextLinkRef === null || nextLinkRef === void 0 ? void 0 : nextLinkRef.current), err);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setLoadData(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLoad() {
            return _ref.apply(this, arguments);
        };
    }();
    var cloneListArticles = (0,_to_consumable_array/* default */.Z)(listArticles);
    // console.log({ cloneListArticles, articles });
    var onTopArticle = cloneListArticles.splice(0, 5);
    var baseUrlCategory = "".concat(constants/* APP_URL */.FX, "/category/").concat(category === null || category === void 0 ? void 0 : category.en);
    var _article = {
        title: (meta === null || meta === void 0 ? void 0 : meta.title) || layout/* WEB_TITLE */.qN,
        description: (meta === null || meta === void 0 ? void 0 : meta.description) || layout/* WEB_DESC */.a0,
        keyword: (meta === null || meta === void 0 ? void 0 : meta.keyword) || layout/* WEB_KEYWORD */.kG
    };
    var setItemListElement = "";
    if (subCategory === null || subCategory === void 0 ? void 0 : subCategory.en) {
        baseUrlCategory = "".concat(constants/* APP_URL */.FX, "/category/").concat(category === null || category === void 0 ? void 0 : category.en, "/").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.en);
        setItemListElement = '[\n      {\n        "@type": "ListItem",\n        "position": 1,\n        "name": "หน้าแรก",\n        "item": "'.concat(constants/* APP_URL */.FX, '"\n      },\n      {\n        "@type": "ListItem",\n        "position": 2,\n        "name": "').concat(category === null || category === void 0 ? void 0 : category.th, '",\n        "item": "').concat(constants/* APP_URL */.FX, "/category/").concat(category === null || category === void 0 ? void 0 : category.en, '"\n      },\n      {\n        "@type": "ListItem",\n        "position": 3,\n        "name": "').concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.th, '",\n        "item": "').concat(baseUrlCategory, '"\n      }\n    ]');
    } else {
        setItemListElement = '[\n      {\n        "@type": "ListItem",\n        "position": 1,\n        "name": "หน้าแรก",\n        "item": "'.concat(constants/* APP_URL */.FX, '"\n      },\n        {\n          "@type": "ListItem",\n          "position": 2,\n          "name": "').concat(category === null || category === void 0 ? void 0 : category.th, '",\n          "item": "').concat(constants/* APP_URL */.FX, "/category/").concat(category === null || category === void 0 ? void 0 : category.en, '"\n        }\n      ]');
    }
    var sub = router.query.sub;
    // const adsPremiumList = ['business'];
    // const adsFinanceList = ['business_finance'];
    // const adsEducationList = ['social_education'];
    // const isTabletOrMobile = useMediaQuery({ maxWidth: 768 });
    // console.log(nextLinkRef);
    // const titleEscape = escapeChar(meta.title);
    var categoryNameTH = (subCategory === null || subCategory === void 0 ? void 0 : subCategory.th) ? subCategory === null || subCategory === void 0 ? void 0 : subCategory.th : (category === null || category === void 0 ? void 0 : category.th) === "ข่าวล่าสุด" ? "Latest News" : category === null || category === void 0 ? void 0 : category.th;
    var isDesktop = (0,device/* useDesktop */.Ln)();
    var isStickyAdCategory = constants/* STICKY_AD_CATEGORIES */.Zj === null || constants/* STICKY_AD_CATEGORIES */.Zj === void 0 ? void 0 : constants/* STICKY_AD_CATEGORIES.includes */.Zj.includes(category === null || category === void 0 ? void 0 : category.en);
    var sentinelRef = (0,react.useRef)(null); // sentinel วางไว้เหนือ billboard เพื่อดักจับจังหวะ "เริ่ม stick"
    var stickyTimeoutRef = (0,react.useRef)(null);
    var hasStuckRef = (0,react.useRef)(false);
    var isStuckRef = (0,react.useRef)(false);
    var ref5 = (0,react.useState)(0), stickyMenuHeight = ref5[0], setStickyMenuHeight = ref5[1]; // ความสูงเมนู sticky เดิม
    var ref6 = (0,react.useState)(false), isReleased = ref6[0], setIsReleased = ref6[1]; // true = ปลด sticky หลังครบ 5 วิ
    var ref7 = (0,react.useState)(false), isStuck = ref7[0], setIsStuck = ref7[1];
    var adsRef = (0,react.useRef)(null);
    var ref8 = (0,react.useState)(null), adsHeight = ref8[0], setAdsHeight = ref8[1];
    (0,react.useEffect)(function() {
        isStuckRef.current = isStuck && !isReleased;
    }, [
        isStuck,
        isReleased
    ]);
    (0,react.useEffect)(function() {
        var headerEl = document.querySelector(".header-desktop");
        var updateMenuHeight = function() {
            return setStickyMenuHeight(headerEl ? headerEl.offsetHeight : 0);
        };
        updateMenuHeight();
        window.addEventListener("resize", updateMenuHeight);
        return function() {
            return window.removeEventListener("resize", updateMenuHeight);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!adsRef.current) return;
        var ro = new ResizeObserver(function(entries) {
            var ref, ref1;
            if (isStuckRef.current) return;
            var h = (ref = entries[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.contentRect) === null || ref1 === void 0 ? void 0 : ref1.height;
            if (h && h > 0) setAdsHeight(h);
        });
        ro.observe(adsRef.current);
        return function() {
            return ro.disconnect();
        };
    }, [
        ads
    ]);
    (0,react.useEffect)(function() {
        if (!isDesktop || !isStickyAdCategory || !sentinelRef.current) return;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            if (!entry.isIntersecting) {
                if (!hasStuckRef.current) {
                    hasStuckRef.current = true;
                    setIsStuck(true);
                    setIsReleased(false);
                    if (stickyTimeoutRef.current) clearTimeout(stickyTimeoutRef.current);
                    stickyTimeoutRef.current = setTimeout(function() {
                        setIsReleased(true);
                        setIsStuck(false);
                    }, constants/* STICKY_AD_DURATION */.GK);
                }
            } else {
                hasStuckRef.current = false;
                setIsStuck(false);
                setIsReleased(false);
                if (stickyTimeoutRef.current) {
                    clearTimeout(stickyTimeoutRef.current);
                    stickyTimeoutRef.current = null;
                }
            }
        }, {
            rootMargin: "-".concat(stickyMenuHeight, "px 0px 0px 0px"),
            threshold: 0
        });
        observer.observe(sentinelRef.current);
        return function() {
            observer.disconnect();
            if (stickyTimeoutRef.current) clearTimeout(stickyTimeoutRef.current);
        };
    }, [
        isDesktop,
        isStickyAdCategory,
        stickyMenuHeight
    ]); // จะ re-run อีกครั้งพอ stickyMenuHeight อัปเดตจาก 0 เป็นค่าจริง
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default */.Z), {
                title: _article === null || _article === void 0 ? void 0 : _article.title,
                description: _article === null || _article === void 0 ? void 0 : _article.description,
                openGraph: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default.openGraph */.Z.openGraph), {
                    title: _article === null || _article === void 0 ? void 0 : _article.title,
                    description: _article === null || _article === void 0 ? void 0 : _article.description,
                    url: baseUrlCategory
                }),
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: _article === null || _article === void 0 ? void 0 : _article.keyword
                    }
                ],
                robotsProps: {
                    maxImagePreview: "large",
                    maxSnippet: -1,
                    maxVideoPreview: -1
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: baseUrlCategory
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: _article === null || _article === void 0 ? void 0 : _article.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: _article === null || _article === void 0 ? void 0 : _article.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: layout/* IMAGE_DEFAULT */.TH
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: '\n                 __th_page="'.concat((subCategory === null || subCategory === void 0 ? void 0 : subCategory.en) ? subCategory.en : category === null || category === void 0 ? void 0 : category.en, '";\n            ')
                        }
                    }),
                    !(0,device/* useDesktop */.Ln)() && !isEmpty_default()(dataAdsHeader) ? (0,html_react_parser/* default */.ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_mobile)) : "",
                    (0,device/* useDesktop */.Ln)() && !isEmpty_default()(dataAdsHeader) ? (0,html_react_parser/* default */.ZP)("".concat(dataAdsHeader === null || dataAdsHeader === void 0 ? void 0 : dataAdsHeader.header_desktop)) : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        async: true,
                        type: "text/javascript",
                        src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                            __html: "var googletag = googletag || {}; window.googletag.cmd = googletag.cmd || [];"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n              {\n                "@context": "https://schema.org",\n                "@type": "WebSite",\n                "name": "'.concat(layout/* WEB_NAME */.Ey, '",\n                "url": "').concat(layout/* WEB_URL.WEB */.h$.WEB, '",\n                "description": "').concat(_article === null || _article === void 0 ? void 0 : _article.description, '",\n                "sameAs": [\n                  "').concat(layout/* WEB_URL.FACEBOOK */.h$.FACEBOOK, '",\n                  "').concat(layout/* WEB_URL.TWITTER */.h$.TWITTER, '",\n                  "').concat(layout/* WEB_URL.INSTAGRAM */.h$.INSTAGRAM, '",\n                  "').concat(layout/* WEB_URL.YOUTUBE */.h$.YOUTUBE, '",\n                  "').concat(layout/* WEB_URL.LINE */.h$.LINE, '"\n                ],\n                "potentialAction": {\n                  "@type": "SearchAction",\n                  "target": "').concat(layout/* WEB_URL.WEB */.h$.WEB, 'search?q={search_term_string}",\n                  "query-input": "required name=search_term_string"\n                }\n              }\n            ')
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n                {\n                  "@context": "http://schema.org",\n                  "@type": "WebPage",\n                  "name": "'.concat(categoryNameTH, '",\n                  "description": "').concat(_article === null || _article === void 0 ? void 0 : _article.description, '",\n                  "publisher": {\n                    "@type": "ProfilePage",\n                    "name": "').concat(layout/* WEB_NAME */.Ey, '"\n                  }\n                }\n              ')
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: '\n              {\n                "@context": "http://schema.org",\n                "@type": "BreadcrumbList",\n                "itemListElement": '.concat(setItemListElement, "\n              }\n            ")
                        }
                    })
                ]
            }),
            !isEmpty_default()(dataAffiliate) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionAffiliate, {
                position: 4,
                data: dataAffiliate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts["default"], {
                sessionSevId: sessionSevId,
                children: [
                    !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                        position: dynamic_ads.KEY_ADS_POSITION.LIGHTBOX,
                        data: ads,
                        handler: function() {
                            return handleLightBoxClick();
                        },
                        adsBox: adsBox
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: sentinelRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BillboardWrapper, {
                        $position: isDesktop && isStickyAdCategory && !isReleased,
                        $pinned: isStuck && !isReleased,
                        ref: adsRef,
                        $fixedHeight: adsHeight,
                        $topOffset: stickyMenuHeight,
                        children: !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                            position: dynamic_ads.KEY_ADS_POSITION.BILLBOARD,
                            data: ads
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper, {
                        id: "section-1",
                        className: "category-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(widget_breadcrumb["default"], {
                                    article: {
                                        section: category,
                                        subCategory: subCategory
                                    }
                                }),
                                sub === "upcoming" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "heading-title",
                                            style: {
                                                filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
                                            },
                                            children: "อีเวนต์ที่กำลังจะมาถึง"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventGrid, {
                                            style: {
                                                filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
                                            },
                                            children: !isEmpty_default()(sectionEvent) && sectionEvent.map(function(item, index) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(event_card, {
                                                    item: item,
                                                    index: index,
                                                    onClick: function(item, index) {
                                                        (0,send_datalayer/* sendDataLayerGlobal */.dE)({
                                                            type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                                            section: "อีเวนต์ที่กำลังจะมาถึง",
                                                            position: "หน้า upcoming",
                                                            data: {
                                                                title: item === null || item === void 0 ? void 0 : item.title,
                                                                index: index + 1,
                                                                heading: "อีเวนต์ที่กำลังจะมาถึง"
                                                            }
                                                        });
                                                    }
                                                }, index);
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "heading-title",
                                            style: {
                                                filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
                                            },
                                            children: categoryNameTH
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-lg-8 col-md-12",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "row",
                                                            style: {
                                                                filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
                                                            },
                                                            children: listArticles.length < 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col-12 no-article",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "".concat(constants/* APP_IMG */.T, "/no-article.png"),
                                                                    alt: "no-article",
                                                                    width: "100%"
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "col-12",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFullH, {
                                                                                data: onTopArticle,
                                                                                heading: false,
                                                                                include: false,
                                                                                txtSize: (0,device/* isRender */.Q0)("desktop") ? "--large" : "--small",
                                                                                ads: ads,
                                                                                //! DATALAYER
                                                                                eventDataLayer: {
                                                                                    type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                                    router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                                    section: "ข่าวทั้งหมด",
                                                                                    position: "ใต้:โฆษณาตำแหน่ง billboard",
                                                                                    data: {
                                                                                        block: "1",
                                                                                        heading: categoryNameTH
                                                                                    }
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "row",
                                                                                children: cloneListArticles.slice(0, show).map(function(item, index) {
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                                                        id: index + 1,
                                                                                        className: "col-6 col-md-4 mb-3",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardV, {
                                                                                            data: item,
                                                                                            description: false,
                                                                                            badge: true,
                                                                                            path: item.link,
                                                                                            //! DATALAYER
                                                                                            eventDataLayer: {
                                                                                                type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                                                section: "ข่าวทั้งหมด",
                                                                                                position: "ใต้:โฆษณาตำแหน่ง billboard",
                                                                                                data: {
                                                                                                    block: "1",
                                                                                                    title: item.title,
                                                                                                    heading: categoryNameTH,
                                                                                                    index: index + 6
                                                                                                }
                                                                                            }
                                                                                        })
                                                                                    }, item.id);
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContainer, {
                                                                        children: loadData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                                                                            children: " Loading ... "
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            onClick: handleLoad,
                                                                            children: " ดูเพิ่มเติม"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            id: "postartice",
                                                            className: "ads-sticky-overflow",
                                                            children: !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                                position: dynamic_ads.KEY_ADS_POSITION.POSTARTICLE,
                                                                data: ads
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-lg-4 col-md-12 d-lg-block d-none",
                                                    children: StickyBox && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyBox, {
                                                        offsetTop: 70,
                                                        offsetBottom: 70,
                                                        children: [
                                                            !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                                position: dynamic_ads.KEY_ADS_POSITION.STICKY_1,
                                                                data: ads
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "widget-content",
                                                                style: {
                                                                    filter: constants/* SHOW_COMMEMORATE */.WT === "true" ? "grayscale(0.7)" : "unset"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(widget_heading["default"], {
                                                                        heading: "Latest News"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "block-content",
                                                                        children: Array.isArray(lastNews) && lastNews.length < 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "no-article",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                className: "--side",
                                                                                src: "".concat(constants/* APP_IMG */.T, "/no-article.png"),
                                                                                alt: "no-article",
                                                                                width: "100%"
                                                                            })
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                            className: "block-list",
                                                                            children: lastNews.slice(0, 4).map(function(item, index) {
                                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardH, {
                                                                                        data: item,
                                                                                        large: false,
                                                                                        //! DATALAYER
                                                                                        eventDataLayer: {
                                                                                            type: send_datalayer/* DATALAYER_TYPE.TRACK_POSITION */.$7.TRACK_POSITION,
                                                                                            router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                                            section: "Latest News",
                                                                                            position: "ใต้:โฆษณาตำแหน่ง Sticky Box",
                                                                                            data: {
                                                                                                block: "2",
                                                                                                title: item.title,
                                                                                                heading: "Latest News",
                                                                                                index: index + 1
                                                                                            }
                                                                                        }
                                                                                    })
                                                                                }, index);
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                                                                position: dynamic_ads.KEY_ADS_POSITION.STICKY_2,
                                                                data: ads
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    !isEmpty_default()(ads) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicAds, {
                        position: dynamic_ads.KEY_ADS_POSITION.AD1X1,
                        data: ads
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _cid_ = (PageCategory);
var ButtonContainer = styled_components_browser_esm["default"].div(_cid_templateObject());
var SectionWrapper = styled_components_browser_esm["default"].div(_templateObject1());
var EventGrid = styled_components_browser_esm["default"].div(_templateObject2());
var BillboardWrapper = styled_components_browser_esm["default"].div(_templateObject3(), function(param) {
    var $position = param.$position, $topOffset = param.$topOffset;
    return $position && "\n      position: sticky;\n      top: ".concat($topOffset, "px;\n      z-index: 9;\n    ");
}, function(param) {
    var $fixedHeight = param.$fixedHeight;
    return $fixedHeight && "\n      .desktop .ads-billboard {\n        min-height: ".concat($fixedHeight, "px;\n      }\n    ");
}, function(param) {
    var $pinned = param.$pinned;
    return $pinned && "\n      .desktop .ads-billboard {\n        background: none;\n        min-height: unset;\n      }\n    ";
});


/***/ }),

/***/ 477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34892);





var Link = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _href = _param.href, href = _href === void 0 ? "" : _href, _title = _param.title, title = _title === void 0 ? "" : _title, _target = _param.target, target = _target === void 0 ? "_self" : _target, _nofollow = _param.nofollow, nofollow = _nofollow === void 0 ? false : _nofollow, eventDataLayer = _param.eventDataLayer, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "href",
        "title",
        "target",
        "nofollow",
        "eventDataLayer",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className,
        title: title,
        target: target,
        href: href,
        rel: "noopener noreferrer ".concat(nofollow ? "nofollow" : ""),
        // ยิง datalayer เฉพาะตอนได้รับ eventDataLayer ที่มี type จริง
        // กันเคสการ์ดที่ไม่ได้ส่ง eventDataLayer มา (เดิม <Link> จะยิงก้อนว่างทับของจริง = "คลิกแล้วไม่ได้ค่า")
        onClick: (eventDataLayer === null || eventDataLayer === void 0 ? void 0 : eventDataLayer.type) ? function() {
            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_1__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, eventDataLayer));
        } : undefined
    }, props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 36552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15072);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.breadcrumb {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    min-height: 40px;\n    li {\n      font-size: 16pt;\n      min-height: 30px;\n      &.more-cate {\n        a {\n          color: var(--primary-color);\n        }\n      }\n      color: var(--primary-color);\n    }\n    li + li {\n      &:before {\n        content: '>';\n        padding: 0 10px;\n        color: var(--primary-color);\n      }\n    }\n    @media (max-width: 767px) {\n      justify-content: center;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function WidgetBreadcrumb(param) {
    var article = param.article;
    var ref, ref1, ref2, ref3;
    // console.log('article', article);
    var categoryName = ((ref = article.section) === null || ref === void 0 ? void 0 : ref.th) === "ข่าวล่าสุด" ? "Latest News" : (ref1 = article.section) === null || ref1 === void 0 ? void 0 : ref1.th;
    var subCategoryName = article.subCategory ? article.subCategory.th : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WidgetWrapper, {
        className: "breadcrumb",
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    href: "/",
                    children: "หน้าแรก"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                className: "more-cate",
                children: [
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: "".concat(categoryName ? "/category/".concat(article === null || article === void 0 ? void 0 : (ref2 = article.section) === null || ref2 === void 0 ? void 0 : ref2.en) : ""),
                        children: categoryName
                    })
                ]
            }),
            subCategoryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                className: "more-cate",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: "".concat("/category/".concat(article === null || article === void 0 ? void 0 : (ref3 = article.section) === null || ref3 === void 0 ? void 0 : ref3.en, "/").concat(article.subCategory.en)),
                        children: subCategoryName
                    }),
                    " "
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (WidgetBreadcrumb);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].ul(_templateObject());


/***/ }),

/***/ 2657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ WidgetHeading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2777);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15072);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34892);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(186);
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(477);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  align-items: baseline;\n  border-bottom: 3px solid var(--primary-color);\n\n  h2 {\n    background: var(--white-color);\n    color: var(--text-color);\n    width: fit-content;\n    font-family: 'DBHelvethaicaXBd', sans-serif;\n    padding: 5px 15px 5px 0px;\n    border-radius: 10px 10px 0 0px;\n    font-size: 28pt;\n    font-weight: 400;\n    margin-bottom: -13px;\n    letter-spacing: 0px;\n    text-transform: uppercase;\n\n    @media (max-width: 768px) {\n      font-size: 24pt;\n    }\n    // @media (max-width: 768px) {\n    //   font-family: 'DBHelvethaicaXBd', sans-serif;\n    //   font-weight: 500;\n    // }\n    span {\n      color: #f10300;\n    }\n  }\n  a h2 {\n    cursor: pointer;\n    transition: all 0.5s ease-out;\n    :hover {\n      transform: scale(1.05);\n    }\n  }\n  .text-read {\n    color: var(--primary-color);\n    cursor: pointer;\n    font-size: 12pt;\n    font-weight: 500;\n    background: var(--white-color);\n    margin-bottom: -10px;\n    padding-left: 10px;\n\n    /* padding-bottom: 8px; */\n    svg {\n      color: var(--primary-color);\n      margin-left: -3px;\n    }\n    &:hover {\n      svg {\n        color: var(--hover-color);\n      }\n      color: var(--hover-color);\n    }\n  }\n\n  .heading {\n    &.--hover {\n      &:hover {\n        color: #0600e7;\n      }\n    }\n    &.--live {\n      font-size: 24pt;\n    }\n  }\n\n  .live-button {\n    svg {\n      margin-right: 7px;\n      margin-bottom: 4px;\n    }\n    svg path {\n      fill: red;\n      /* Copy this @keyframes block to your CSS*/\n      @keyframes signalanimate {\n        0% {\n          opacity: 0;\n        }\n        50% {\n          opacity: 1;\n        }\n        100% {\n          opacity: 0;\n        }\n      }\n      &:nth-of-type(1) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n      }\n      &:nth-of-type(2) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n        -webkit-animation-delay: 0.5s;\n        animation-delay: 0.5s;\n      }\n      &:nth-of-type(3) {\n        -webkit-animation: signalanimate 2s infinite;\n        animation: signalanimate 2s infinite;\n        -webkit-animation-delay: 1s;\n        animation-delay: 1s;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function WidgetHeading(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "" : _heading, customHeading = param.customHeading, _className = param.className, className = _className === void 0 ? "" : _className, _eventDataLayer = param.eventDataLayer, eventDataLayer = _eventDataLayer === void 0 ? {} : _eventDataLayer, _showReadmore = param.showReadmore, showReadmore = _showReadmore === void 0 ? false : _showReadmore, _link = param.link, link = _link === void 0 ? "" : _link, _isSectionLive = param.isSectionLive, isSectionLive = _isSectionLive === void 0 ? false : _isSectionLive;
    if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_2___default()(heading)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WidgetWrapper, {
        className: "widget-heading ".concat(className),
        style: {
            filter: src_constants__WEBPACK_IMPORTED_MODULE_3__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0.7)" : ""
        },
        children: [
            isSectionLive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h2", {
                className: "heading --live",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                        className: "live-button",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                x: "0px",
                                y: "0px",
                                width: "17px",
                                height: "15.8px",
                                viewBox: "0 0 17 15.8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M8.5,6.8c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7C10.2,7.6,9.5,6.8,8.5,6.8z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M13.6,8.5c0-2.8-2.2-5.1-5-5.2c-2.8,0-5.1,2.2-5.2,5c0,0,0,0.1,0,0.1c0,1.8,1,3.5,2.6,4.4l0.9-1.4c-1.6-1-2.1-3-1.2-4.6s3-2.1,4.6-1.2c1,0.6,1.7,1.7,1.7,2.9c0,1.2-0.6,2.3-1.7,2.9l0.9,1.4C12.7,12,13.6,10.3,13.6,8.5L13.6,8.5z"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                        d: "M8.5,0C3.8,0,0,3.8,0,8.5c0,3,1.6,5.8,4.3,7.3l0.9-1.4c-3.3-1.9-4.4-6.1-2.5-9.3s6.1-4.4,9.3-2.5c2.1,1.2,3.4,3.5,3.4,5.9c0,2.4-1.3,4.7-3.4,5.9l0.9,1.4c4.1-2.3,5.5-7.5,3.1-11.6C14.4,1.6,11.6,0,8.5,0z"
                                    })
                                ]
                            }),
                            "LIVE"
                        ]
                    }),
                    " ",
                    "เกาะติดเลือกตั้ง"
                ]
            }) : link ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: link,
                onClick: function() {
                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventDataLayer));
                },
                children: customHeading !== null && customHeading !== void 0 ? customHeading : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                    className: "heading ".concat(link ? "--hover" : ""),
                    children: heading
                })
            }) : customHeading !== null && customHeading !== void 0 ? customHeading : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "heading ".concat(link ? "--hover" : ""),
                children: heading
            }),
            showReadmore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: link,
                onClick: function() {
                    return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_4__/* .sendDataLayerGlobal */ .dE)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, eventDataLayer));
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                    className: "text-read",
                    children: [
                        "ดูทั้งหมด ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_7__.FiArrowRightCircle, {})
                    ]
                })
            })
        ]
    });
};
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject());


/***/ }),

/***/ 73113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ GET; },
/* harmony export */   "M": function() { return /* binding */ GET_ARTICLES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39334);






// Service : GET ------------------------- */
function GET() {
    return _GET.apply(this, arguments);
}
function _GET() {
    _GET = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    // If don't have data return [];
                    // If have data return [{ id: 1 }] or { data: [] }
                    // If can't call api return { data: null, msg: null }
                    // console.log(timestamp(), _url, ':');
                    if (!data.msg) {
                        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data.data)) {
                            return [
                                2,
                                all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data.data
                            ];
                        }
                        return [
                            2,
                            data
                        ];
                    }
                    return [
                        2,
                        []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat((0,_helper__WEBPACK_IMPORTED_MODULE_2__/* .timestamp */ .AB)(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET.apply(this, arguments);
}
function GET_ARTICLES() {
    return _GET_ARTICLES.apply(this, arguments);
}
function _GET_ARTICLES() {
    _GET_ARTICLES = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, _tmp2, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    if ((data === null || data === void 0 ? void 0 : data.statusCode) === 404) {
                        return [
                            2,
                            data
                        ];
                    } else if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data === null || data === void 0 ? void 0 : data.data)) {
                        return [
                            2,
                            all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data === null || data === void 0 ? void 0 : data.data
                        ];
                    }
                    _tmp2 = {};
                    return [
                        2,
                        all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp2, data) : []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat(new Date().toUTCString(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET_ARTICLES.apply(this, arguments);
}


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [601,2777,7817,6126,106,9774,2888,179], function() { return __webpack_exec__(47635); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);